import { isApplicationProfileDeactivated } from './applicationAvailability'

export const getSelectedApplicantProfile = (
	matches = [],
	selectedApplicantId
) => {
	if (!selectedApplicantId || !Array.isArray(matches)) {
		return null
	}

	// IDs arrive as strings from route/query state and numbers from API payloads.
	return matches.find(profile => profile.id == selectedApplicantId) || null
}

export const getSelectedApplicantMatch = (
	matches = [],
	selectedApplicantId
) => {
	const profile = getSelectedApplicantProfile(matches, selectedApplicantId)
	return profile?.match || null
}

export const getApplicationApplicantId = application =>
	application?.applicant_profile_id || application?.applicant_profile?.id

export const buildApplicantNavigationIds = ({
	applications = [],
	selectedApplication = null,
	selectedApplicantId = null,
	showApplicantModal = false
} = {}) => {
	const ids = applications
		.filter(application => !isApplicationProfileDeactivated(application))
		.map(getApplicationApplicantId)
	const selectedApplicationApplicantId = getApplicationApplicantId(
		selectedApplication
	)

	const currentSelectedApplication = applications.find(
		application => getApplicationApplicantId(application) == selectedApplicationApplicantId
	) || selectedApplication

	if (
		showApplicantModal &&
		!isApplicationProfileDeactivated(currentSelectedApplication) &&
		selectedApplicationApplicantId != null &&
		selectedApplicationApplicantId == selectedApplicantId &&
		!ids.some(id => id == selectedApplicationApplicantId)
	) {
		return [selectedApplicationApplicantId, ...ids]
	}

	return ids
}

export const getApplicationMatchForApplicant = ({
	applications = [],
	selectedApplication = null,
	selectedApplicantId = null
} = {}) => {
	if (!selectedApplicantId) {
		return null
	}

	const selectedApplicationApplicantId = getApplicationApplicantId(
		selectedApplication
	)

	if (selectedApplicationApplicantId == selectedApplicantId) {
		return selectedApplication?.match || null
	}

	const application = applications.find(
		app => getApplicationApplicantId(app) == selectedApplicantId
	)

	return application?.match || null
}

export const buildApplicantHeaderIdentity = ({
	applicantProfile,
	isTalentPoolContext = false
} = {}) => {
	const user = applicantProfile?.user || {}
	const firstname = user.firstname || ''
	const lastname = user.lastname || ''
	const fullName = isTalentPoolContext
		? firstname
		: `${firstname} ${lastname}`.trim()

	const email = isTalentPoolContext
		? null
		: user.email || applicantProfile?.email || null

	const phone = isTalentPoolContext
		? null
		: user.phone ||
		  applicantProfile?.mobile ||
		  applicantProfile?.phone ||
		  null

	const rawLink = isTalentPoolContext
		? null
		: applicantProfile?.linkedin_url || null

	const normalizedRawLink =
		typeof rawLink === 'string' ? rawLink.trim() : null

	const hasSupportedProtocol =
		normalizedRawLink?.startsWith('http://') ||
		normalizedRawLink?.startsWith('https://')

	const looksLikeExternalUrl =
		normalizedRawLink &&
		normalizedRawLink.includes('.') &&
		!normalizedRawLink.startsWith('/')

	const profileLink = !normalizedRawLink
		? null
		: hasSupportedProtocol
		? normalizedRawLink
		: looksLikeExternalUrl
		? `https://${normalizedRawLink}`
		: null

	return {
		fullName,
		email,
		phone,
		profileLink
	}
}

export const isApplicationHistoryEnabled = ({
	hasOrganization = false,
	hasApplication = false,
	jobOfferId = null,
	isTalentPoolContext = false
} = {}) => {
	return Boolean(
		hasOrganization && hasApplication && jobOfferId && !isTalentPoolContext
	)
}
